<template lang="pug">
  v-banner.text-center( app v-model="showDebtorWarningBanner" color="warning")
    div.text-h6.font-weight-bold.white--text( @click="transfer" ) {{ $t('debtorWarningBanner.warningText') }}
    div( @click="transfer" ).blue--text.text--darken-3 {{ $t('debtorWarningBanner.moreInformationText') }}

</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import router from "@/router";

@Component({
  components: {}
})

export default class DebtorWarningBanner extends Vue {

  @Prop({type: Boolean, default: false}) showDebtorWarningBanner!: boolean

  transfer(): void {
    router.push("/billing")
  }
}
</script>

<style lang="stylus" scoped>
  .v-banner {
    cursor pointer
  }
</style>